import * as ResultsError from './components/ResultsError.css';
var defaultTheme = {
    ResultsError: ResultsError
};
export default defaultTheme;
